module.exports = __webpack_public_path__ + "img/background3.3d8dfe46.jpg";